import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

import "./NavigationMenu.css";
import { FolderMenu } from "../folder-menu/FolderMenu";
import { MenuTitle } from "./menu-title/MenuTitle";

export const NavigationMenu = ({
    folders,
    setFolders,
    selectedCollectionId,
    onAddFolder,
    onSelectCollection,
    onMoveCollectionToFolder,
    onDeleteFolder,
    onRestoreElement,
    onRestoreCollection,
    onRestoreFolder,
    areSecretCollectionsVisible,
    onRequestSecretCollectionsVisibility,
    onRequestSetPin,
    onRequestChangePin,
    onRequestDeletePin,
    onRequestSecretCollectionCreation,
    onRestoreBackup,
    isInstallAvailable,
    onInstallApp,
}) => {
    const [showListMenu, setShowListMenu] = useState(false);

    return (
        <>
            <div className="navigation-menu-container">
                <div className="navigation-menu">
                    <MenuTitle title="MinderBox" />
                    <FontAwesomeIcon
                        onClick={() => setShowListMenu(true)}
                        className="menu-icon"
                        icon={faBars}
                    />
                </div>
            </div>
            {showListMenu && (
                <>
                    <div 
                        className="folder-menu-overlay"
                        onClick={() => setShowListMenu(false)}
                    />
                    <FolderMenu
                        folders={folders}
                        setFolders={setFolders}
                        setShowListMenu={setShowListMenu}
                        selectedCollectionId={selectedCollectionId}
                        onAddFolder={onAddFolder}
                        onSelectCollection={onSelectCollection}
                        onMoveCollectionToFolder={onMoveCollectionToFolder}
                        onDeleteFolder={onDeleteFolder}
                        onRestoreElement={onRestoreElement}
                        onRestoreCollection={onRestoreCollection}
                        onRestoreFolder={onRestoreFolder}
                        areSecretCollectionsVisible={areSecretCollectionsVisible}
                        onRequestSecretCollectionsVisibility={onRequestSecretCollectionsVisibility}
                        onRequestSetPin={onRequestSetPin}
                        onRequestChangePin={onRequestChangePin}
                        onRequestDeletePin={onRequestDeletePin}
                        onRequestSecretCollectionCreation={onRequestSecretCollectionCreation}
                        onRestoreBackup={onRestoreBackup}
                        isInstallAvailable={isInstallAvailable}
                        onInstallApp={onInstallApp}
                    />
                </>
            )}
        </>
    );
};
